module.exports = __webpack_public_path__ + "img/shqx-ico-8.e783058c.png";